const closeCreditAccountRoutes = {
    chooseAccountUrl: 'choose-payment-account',
    worthKnowingUrl: 'worth-knowing',
    feedbackUrl: '',
    summaryUrl: 'summary',
};

export default closeCreditAccountRoutes;
